module.exports = __webpack_public_path__ + "depart_straight.svg?fb13d58773429a22c7c3ebaed5f2c0ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/depart_straight.svg
// module id = 160
// module chunks = 0